// src/components/pages/Default.js
import React from "react";
import Header from "../Header";
import { faChartSimple } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Default = ({ theme }) => {
  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        <Header title="Home" />
        {/* <div className="">
          <h1>Welcome to the Default Page</h1>
          <p>This is the main content area.</p>
        </div> */}
        <div className="bg-gradient-to-br from-white to-blue-50 shadow-md rounded-lg p-8 max-w-4xl mx-auto mt-8 border border-blue-100">
          <div className="flex flex-col md:flex-row items-center md:items-start">
            <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-8">
              <div className="w-24 h-24 rounded-full flex items-center justify-center shadow-lg"
                style={{ backgroundColor: theme.leftNavBackgroundColor }}>
                {/* <svg
                  className="w-12 h-12 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg> */}
                <FontAwesomeIcon icon={faChartSimple} className="w-12 h-12 text-white" />
              </div>
            </div>

            <div className="flex-1">
              <h1 className="text-3xl font-bold text-gray-800 mb-4">
                Welcome to the Dashboard
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                This is your central hub for accessing all dashboard features
                and analytics. 
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h3 className="font-semibold mb-2" style={{ color: theme.leftNavBackgroundColor}}>
                    View Analytics
                  </h3>
                  <p className="text-sm text-gray-600">
                    Access real-time data and performance metrics
                  </p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h3 className="font-semibold mb-2" style={{ color: theme.leftNavBackgroundColor}}>
                    Manage Dashboards
                  </h3>
                  <p className="text-sm text-gray-600">
                    Create and customize your dashboard views
                  </p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h3 className="font-semibold  mb-2" style={{ color: theme.leftNavBackgroundColor}}>
                    User Settings
                  </h3>
                  <p className="text-sm text-gray-600">
                    Update your profile and preferences
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Default;
